import {
  configureStore,
  type ThunkAction,
  type Action,
  combineReducers,
  type Reducer,
  type AnyAction,
} from '@reduxjs/toolkit'
import authReducer from 'features/authentication/auth.slice'
import vendorReducer from 'features/vendor/vendor.slice'
import bidReducer from 'features/bids/bid.slice'
import vendorListReducer from 'features/vendors/vendorList.slice'
import lookupReducer from 'features/lookup/lookup.slice'
import { enableMapSet } from 'immer'
import requestsReducer from 'common/requests/requests.slice'
import StakeholderReducer from 'common/stakeholder-profile-page/stakeholder.slice'
import UsersReducer from 'common/users/users-page.slice'
import QuestionnairesReducer from 'features/vendor/questionnaires/questionnaires.slice'

import appReducer from './app.slice'

const combinedReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  vendor: vendorReducer,
  bid: bidReducer,
  vendorList: vendorListReducer,
  lookup: lookupReducer,
  stakeholderProfilePage: StakeholderReducer,
  requests: requestsReducer,
  users: UsersReducer,
  questionnaires: QuestionnairesReducer,
})
const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'app/logout') {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state = {} as RootState
  }
  return combinedReducer(state, action)
}
enableMapSet()
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof combinedReducer>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
